import { useMemo } from 'react';
import type { FormControl } from '@atlas-forms/types-js';

export interface FormScopePartition {
  /** Controls with scope 'field' (or no scope) — rendered in the form grid */
  fieldControls: FormControl[];
  /** Controls with scope 'form' — processed by FormScopeProcessor */
  formScopeControls: FormControl[];
}

export function useFormScopePartition(controls: FormControl[]): FormScopePartition {
  return useMemo(() => ({
    fieldControls: controls.filter(c => (c.scope ?? 'field') === 'field'),
    formScopeControls: controls.filter(c => c.scope === 'form'),
  }), [controls]);
}
